import { createNote } from "./helpers/manage-notes";
import { setFilters } from "./helpers/filters";
import { renderNotes } from "./helpers/views";

renderNotes();

document.querySelector("#create-new").addEventListener("click", e => {
  const uid = createNote();
  location.assign(`/note_data.html#${uid}`);
});

document.querySelector("#text-search").addEventListener("input", e => {
  setFilters({
    searchText: e.target.value
  });
  renderNotes();
});

document.querySelector("#filter-by").addEventListener("change", e => {
  setFilters({
    sortBy: e.target.value
  });
  renderNotes();
});

window.addEventListener("storage", e => {
  if (e.key === "notes") {
    renderNotes();
  }
});
